module.exports = __webpack_public_path__ + "static/media/5@2x.2e539e7d.png";